import type { CampaignName } from 'src/common/enums/campaigns';
import type { CampaignDTO, CampaignStorage, NotApplicableCampaignStorage } from 'src/common/interfaces/campaigns';
import {
  INFLUENCER_SUBSCRIPTION_ADDITIONAL_CONFIGS,
  type InfluencerSubscriptionCampaigns,
} from '../influencers/influencers.config';

export const CAMPAIGN_STORAGE_KEY = 'thm_campaigns';
export const CAMPAIGN_NOT_APPLICABLE_STORAGE_KEY = 'thm_not_applicable_campaign';

const defaultStorageData: CampaignStorage = {
  activeCampaign: null,
  seenCampaigns: [],
};

const defaultNotApplicableCampaignStorageData: NotApplicableCampaignStorage = {
  campaignFriendlyName: '',
  campaignName: '' as CampaignName,
};

export const readStoredCampaigns = (): CampaignStorage => {
  try {
    const stored = localStorage.getItem(CAMPAIGN_STORAGE_KEY) || '';
    return (JSON.parse(stored) as CampaignStorage) || defaultStorageData;
  } catch {
    return defaultStorageData;
  }
};

export const readStoredNotApplicableCampaign = (): NotApplicableCampaignStorage => {
  try {
    const stored = localStorage.getItem(CAMPAIGN_NOT_APPLICABLE_STORAGE_KEY) || '';
    return (JSON.parse(stored) as NotApplicableCampaignStorage) || defaultNotApplicableCampaignStorageData;
  } catch {
    return defaultNotApplicableCampaignStorageData;
  }
};

export const storeCampaigns = (campaigns: CampaignStorage) => {
  localStorage.setItem(CAMPAIGN_STORAGE_KEY, JSON.stringify(campaigns));
};

export const storeNotApplicableCampaign = (campaign: NotApplicableCampaignStorage) => {
  localStorage.setItem(CAMPAIGN_NOT_APPLICABLE_STORAGE_KEY, JSON.stringify(campaign));
};

export const removeNotApplicableCampaign = () => {
  localStorage.removeItem(CAMPAIGN_NOT_APPLICABLE_STORAGE_KEY);
};

export const setActiveCampaign = (campaign: CampaignDTO) => {
  storeCampaigns({
    ...readStoredCampaigns(),
    activeCampaign: {
      name: campaign.name,
      sessionExpiration: Date.now() + campaign.sessionExpiration!,
    },
  });
};

export const setNotApplicableCampaign = (campaignName: InfluencerSubscriptionCampaigns) => {
  const campaign = INFLUENCER_SUBSCRIPTION_ADDITIONAL_CONFIGS[campaignName];

  if (campaign)
    storeNotApplicableCampaign({
      campaignName,
      campaignFriendlyName: campaign.userFriendlyName,
    });
};
